var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('timetableview.label')))]),_c('br'),_c('vSelect',{attrs:{"options":_vm.timetableViewOptions,"reduce":label => label.code,"disabled":_vm.disabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }